import {SeoErrorsFactory} from '../Errors/factory.js'
import {MakeModelFaqsRequest} from './MakeModelFaqsRequest.js'
import {SeoDataRequest} from './SeoDataRequest.js'
import {TagCloudSeoRequest} from './TagCloudSeoRequest.js'

export class SeoRequestsFactory {
  static seoDataRequest = ({
    culture,
    hasAttributes,
    pageName,
    params: {
      articlePlainText,
      author,
      bodyType,
      bodyTypeIds,
      breadcrumb,
      canonical,
      category,
      category2,
      categoryId,
      cc,
      city,
      color,
      commitmentMonths,
      cons,
      context,
      dealer,
      dealerName,
      dealerSlug,
      description,
      doors,
      entry,
      faqs,
      filteredOfferTypeId,
      fuelType,
      fuelTypeId,
      highPrice,
      image,
      imageUrls,
      initDate,
      isCrawlableAndIndexable,
      keywordSlug,
      kms,
      listingSectionId,
      litres,
      location,
      lowPrice,
      make,
      makeId,
      makes,
      makeSlug,
      maxPrice,
      minPrice,
      model,
      modelId,
      models,
      modelSlug,
      month,
      monthlySubscriptionFee,
      nResults,
      offerCount,
      offerType,
      offerTypeId,
      originUrl,
      page,
      path,
      price,
      pros,
      province,
      provinceId,
      publicationDate,
      rating,
      region,
      regionId,
      searchResults,
      searchTerm,
      seats,
      section,
      sellerTypeId,
      sortBy,
      sortOrder,
      subscriptionVehicleState,
      tag,
      targetBuyer,
      term,
      title,
      totalPages,
      type,
      updateDate,
      valoration,
      vehicleId,
      vehicles,
      vehicleType,
      version,
      versionId,
      video,
      year,
      adId,
      photos,
      km,
      hp,
      fuelTankCapacity,
      consumptionAverage,
      emissions,
      transmissionType,
      warrantyMonths,
      hasWarranty,
      hasOfficialWarranty,
      hasStock,
      sellerDealer,
      dealerReviews,
      adDescription,
      environmentalLabel,
      environmentalLabelValue,
      transmission,
      maxKms
    } = {},
    preloadImages
  } = {}) => {
    SeoDataRequest.validate({
      culture,
      pageName,
      invalidSeoDataRequestError: SeoErrorsFactory.seoDataRequestError
    })

    return new SeoDataRequest({
      culture,
      hasAttributes,
      pageName,
      params: {
        articlePlainText,
        author,
        bodyType,
        bodyTypeIds,
        breadcrumb,
        canonical,
        category,
        category2,
        categoryId,
        cc,
        city,
        color,
        commitmentMonths,
        cons,
        context,
        dealer,
        dealerName,
        dealerSlug,
        description,
        doors,
        entry,
        filteredOfferTypeId,
        faqs,
        fuelType,
        fuelTypeId,
        highPrice,
        image,
        imageUrls,
        initDate,
        isCrawlableAndIndexable,
        keywordSlug,
        kms,
        listingSectionId,
        litres,
        location,
        lowPrice,
        make,
        makeId,
        makes,
        makeSlug,
        maxPrice,
        minPrice,
        model,
        modelId,
        models,
        modelSlug,
        month,
        monthlySubscriptionFee,
        nResults,
        offerCount,
        offerType,
        offerTypeId,
        originUrl,
        page,
        path,
        price,
        pros,
        province,
        provinceId,
        publicationDate,
        rating,
        region,
        regionId,
        searchResults,
        searchTerm,
        seats,
        section,
        sellerTypeId,
        sortBy,
        sortOrder,
        subscriptionVehicleState,
        tag,
        targetBuyer,
        term,
        title,
        totalPages,
        type,
        updateDate,
        valoration,
        vehicleId,
        vehicles,
        vehicleType,
        version,
        versionId,
        video,
        year,
        adId,
        photos,
        km,
        hp,
        fuelTankCapacity,
        consumptionAverage,
        emissions,
        transmissionType,
        warrantyMonths,
        hasWarranty,
        hasOfficialWarranty,
        hasStock,
        sellerDealer,
        dealerReviews,
        adDescription,
        environmentalLabel,
        environmentalLabelValue,
        transmission,
        maxKms
      },
      preloadImages
    })
  }

  static makeModelFaqsRequest = ({make, model}) => {
    MakeModelFaqsRequest.validate({
      make,
      model,
      invalidMakeModelFaqsRequestError: SeoErrorsFactory.makeModelFaqsRequestError
    })
    return new MakeModelFaqsRequest({make, model})
  }

  static tagCloudSeoRequest = ({endpoint, query}) => new TagCloudSeoRequest({endpoint, query})
}
